import { render, staticRenderFns } from "./DialogBase.vue?vue&type=template&id=d9950394&"
import script from "./DialogBase.vue?vue&type=script&lang=js&"
export * from "./DialogBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports